"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (defaultKey) { return ({
    'data-cosmos-key': defaultKey
}); });
//# sourceMappingURL=automation-attribute.js.map